"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.object.define-properties.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/es.weak-map.js");

require("core-js/modules/web.dom-collections.iterator.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "validations", {
  enumerable: true,
  get: function get() {
    return _validations["default"];
  }
});
exports["default"] = void 0;

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.parse-float.js");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _components = require("../../components");

var _formElements = require("@evidation/form-elements");

var _fieldHeight = _interopRequireDefault(require("../../components/fieldHeight"));

var _useTranslated = require("../../hooks/useTranslated");

var _validations = _interopRequireDefault(require("./validations"));

var _excluded = ["input", "unit_type"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var HeightInternational = function HeightInternational(_ref) {
  var _ref$input = _ref.input,
      onChange = _ref$input.onChange,
      name = _ref$input.name,
      _onBlur = _ref$input.onBlur,
      _ref$unit_type = _ref.unit_type,
      unit_type = _ref$unit_type === void 0 ? 'all' : _ref$unit_type,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _useState = (0, _react.useState)(undefined),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      metricHeight = _useState2[0],
      setMetricHeight = _useState2[1];

  var _useState3 = (0, _react.useState)(undefined),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      unitChoice = _useState4[0],
      setUnitChoice = _useState4[1];

  var imperialHeightText = (0, _useTranslated.useTranslated)('fields.heightInternational.enterHeight');
  var metricHeightText = (0, _useTranslated.useTranslated)('fields.heightInternational.enterHeightCentimeters');
  var imperialText = (0, _useTranslated.useTranslated)('fields.heightInternational.imperial');
  var metricText = (0, _useTranslated.useTranslated)('fields.heightInternational.metric'); // Using label feature because it will keep the value the same,
  // but allow us to use translations in the future.

  var unitOptions = [{
    label: imperialText,
    value: 'imperial'
  }, {
    label: metricText,
    value: 'metric'
  }]; // Trigger redux forms onChange event that is passed into the form,
  // this allows customized payload even with multiple field types.

  var handleChange = function handleChange(measurement, units) {
    var _onChange;

    onChange((_onChange = {}, (0, _defineProperty2["default"])(_onChange, name, measurement), (0, _defineProperty2["default"])(_onChange, "".concat(name, "_units"), units), _onChange));
  };

  var isBoth = unit_type.toLowerCase() === 'all';
  var useImperial = isBoth && unitChoice === 'imperial' || unit_type.toLowerCase() === 'imperial';
  var useMetric = isBoth && unitChoice === 'metric' || unit_type.toLowerCase() === 'metric';
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_formElements.InputLabel, props), isBoth && /*#__PURE__*/_react["default"].createElement(_components.SelectInput, (0, _extends2["default"])({}, props, {
    "data-test-id": "selectUnitType",
    meta: _objectSpread(_objectSpread({}, props.meta), {}, {
      error: ''
    }),
    options: unitOptions,
    label: "",
    name: "select_unit_type",
    convertValuesToStrings: false,
    onChange: setUnitChoice,
    value: unitChoice
  })), useImperial && /*#__PURE__*/_react["default"].createElement(_fieldHeight["default"], (0, _extends2["default"])({}, props, {
    input: {
      value: {},
      name: "".concat(name, "_imperial"),
      onBlur: function onBlur(value) {
        _onBlur();

        handleChange(value, 'inches');
      },
      onChange: function onChange(value) {
        return handleChange(value, 'inches');
      }
    },
    label: imperialHeightText
  })), useMetric && /*#__PURE__*/_react["default"].createElement(_components.NumberInput, (0, _extends2["default"])({}, props, {
    name: "".concat(name, "_metric"),
    "data-test-id": "metricHeight",
    onBlur: function onBlur() {
      _onBlur();

      handleChange(parseFloat(metricHeight), 'centimeters');
    },
    onChange: function onChange(_ref2) {
      var value = _ref2.target.value;
      var parseValue = parseFloat(value);
      setMetricHeight(parseValue);
      handleChange(parseFloat(parseValue), 'centimeters');
    },
    label: metricHeightText,
    value: metricHeight,
    error: props.meta.error
  })));
};

var _default = HeightInternational;
exports["default"] = _default;